"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CPriceTier = void 0;
var enums_1 = require("../account/enums");
var interfaces_1 = require("./interfaces");
var CPriceTier = /** @class */function () {
  function CPriceTier(values) {
    if (values === void 0) {
      values = {};
    }
    this.currencyAmounts = [];
    this.is_enabled = false;
    var properties = ['id', 'is_enabled'];
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    if (values.currencyAmounts) {
      this.currencyAmounts = values.currencyAmounts.map(function (value) {
        return new interfaces_1.CCurrencyAmount(value);
      });
    }
  }
  CPriceTier.prototype.getForCurrency = function (currency_id) {
    return this.currencyAmounts.find(function (ca) {
      return ca.currency_id === currency_id;
    });
  };
  CPriceTier.prototype.getAmountByCurrency = function (currency_id) {
    var amount = this.getForCurrency(currency_id);
    if (amount) {
      return amount.amount;
    }
    return null;
  };
  /** @deprecated added for compatibility */
  CPriceTier.prototype.toMeetingPriceTier = function () {
    return {
      id: this.id,
      is_enabled: this.is_enabled,
      amount_usd: this.getAmountByCurrency(enums_1.CurrencyEnum.usd),
      amount_rur: this.getAmountByCurrency(enums_1.CurrencyEnum.rur),
      amount_eur: this.getAmountByCurrency(enums_1.CurrencyEnum.eur)
    };
  };
  return CPriceTier;
}();
exports.CPriceTier = CPriceTier;
